import "@fontsource-variable/red-hat-display";
import "@fontsource/sansita-swashed";
import "@fontsource/sansita-swashed/400.css";
import { createSystem, defaultConfig } from "@chakra-ui/react";
import { buttonRecipe } from "./button.recipe";
import { breadcrumbRecipe } from "./breadcrumb.recipe";
import { selectRecipe } from "./select.recipe";
import { linkRecipe } from "./link.recipe";
import { textareaRecipe } from "./textarea.recipe";
import { textStyles } from "./textStyles";

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        whiteAlfa: {
          100: { value: "#ffffff" },
        },
        darkBackground: {
          100: { value: "#161718" },
          200: { value: "#191919" },
        },
        mainText: {
          100: { value: "#7E7E7E" },
          200: { value: "#363636" },
        },
        yellowC: {
          100: { value: "#FFF9E1" },
          200: { value: "#DBFE01" },
          300: { value: "#C5E500" },
          400: { value: "#F5D048" },
          500: { value: "#F0CB42" },
        },
        purpleC: {
          100: { value: "#B392FF" },
          200: { value: "#7037F5" },
          300: { value: "#5A2DDC" },
        },
        grayC: {
          100: { value: "#CDCDCD" },
          200: { value: "#7A7A7A" },
          300: { value: "#FAFAFA" },
          400: { value: "#EFEFEF" },
          500: { value: "#CED9E9" },
          600: { value: "#EBEBEB" },
          700: { value: "#FCFCFC" },
          800: { value: "#E4E4E4" },
          900: { value: "#F2F5FB" },
        },
        redC: {
          100: { value: "#EB5757" },
        },
        linkBlueC: {
          100: { value: "#0074B9" },
          200: { value: "#0065A2" },
          300: { value: "#00578A" },
        },
        pinkC: {
          100: { value: "#ED77A8" },
        },
        greenC: {
          100: { value: "#6DEB74" },
        },
      },

      fontSizes: {
        "5xl": { value: "50px" },
      },

      fonts: {
        heading: { value: `'Red Hat Display Variable', sans-serif` },
        body: { value: `'Red Hat Display Variable', sans-serif` },
      },
    },
    recipes: {
      button: buttonRecipe,
      breadcrumb: breadcrumbRecipe,
      select: selectRecipe,
      link: linkRecipe,
      textarea: textareaRecipe,
    },
    textStyles: textStyles,
  },

  globalCss: {
    "html, body": {
      margin: 0,
      padding: 0,
      fontFamily: "{fonts.body}",

      color: "{colors.mainText.200}",
    },
    "em, i, cite": {
      fontStyle: "italic",
    },
    "::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b8b8b8", // Scrollbar color
      borderRadius: "8px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#7037F5", // Color on hover
      // background: "#555", // Color on hover
    },
  },
});

export default system;
